function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "logo");
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M755.4,381a93.87,93.87,0,0,0-93.83-92.41h0A93.87,93.87,0,0,0,567.74,381h-.08v2.39h.2c0,105-85.12,190.13-190.13,190.13S187.61,488.4,187.61,383.4h.2V381h-.08A93.87,93.87,0,0,0,93.91,288.6h0A93.87,93.87,0,0,0,.08,381H0v2.39C0,592,169.12,761.14,377.74,761.14S755.48,592,755.48,383.4V381Z",
  fill: "#fff"
});
var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 93.91,
  cy: 93.91,
  r: 93.91,
  fill: "#fff"
});
var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 661.57,
  cy: 93.91,
  r: 93.91,
  fill: "#fff"
});
var SvgWhiteLogoSmall = function SvgWhiteLogoSmall(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 755.48,
    height: 761.14,
    viewBox: "0 0 755.48 761.14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteLogoSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/white-logo-small.0d0c7e3d.svg";
export { ForwardRef as ReactComponent };